import { createSlice } from '@reduxjs/toolkit'

// BE-27. Expense Categories is a purpose-built, narrowed view over the
// CreditCategory resource - not a generic CRUD screen. The form only ever
// exposes 'name': hasDocument, documentModel, type and is_expense are all
// fixed by ExpenseCategoryApiService (false / null / 'cashOut' / true),
// because those are backend plumbing that decides how money moves - not a
// decision the person naming "Rent" or "Utilities" should be making.
export const ExpenseCategorySlice = createSlice({
    name: 'expenseCategory',
    initialState: {
        expenseCategoryList: [],
        formValue: {
            "name": "",
        }
    },
    reducers: {
        onChangeExpenseCategoryFormInput: (state, action) => {
            state.formValue[`${action.payload.name}`] = action.payload.value;
        },
        resetExpenseCategoryFormValue: (state) => {
            Object.keys(state.formValue).forEach((i) => state.formValue[i] = "");
        },
        setExpenseCategoryList: (state, action) => {
            state.expenseCategoryList = action.payload
        },
    },
})

export const {
    onChangeExpenseCategoryFormInput,
    resetExpenseCategoryFormValue,
    setExpenseCategoryList,
} = ExpenseCategorySlice.actions

export default ExpenseCategorySlice.reducer
